import { Base } from '../base-component';
import './accolades-list-blocks.component.scss';

export class AccoladesListBlocks extends Base {

	constructor(element: Element){

		super(element);

	}

	// components
	form: any;
	selectButtons: any;
	selectItems: any;
	clearButton: any;

	init(){

		this.form = this.element.querySelector('#accolades-list-filter');
		this.selectButtons = Array.from(this.element.querySelectorAll('.accolades-list__form-field--select-button'));
		this.selectItems = Array.from(this.element.querySelectorAll('.accolades-list__form-field--select-box-item'));
		this.clearButton = this.element.querySelector('.js-clear-filters');

	}

	bindEvents() {

		if(this.selectButtons){
			this.selectButtons.map((item) => item.addEventListener('click', (event) => {
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
				this.closeAllSelects();
				let parent = element.closest('.accolades-list__form-field--container');
				let box = parent.querySelector('.accolades-list__form-field--select-box');
				box.classList.toggle('accolades-list__form-field--select-box-active');
	
			}));
		}

		if(this.selectItems) {
			this.selectItems.map((item) => item.addEventListener('click', (event) => {
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
				let value = element.getAttribute('data-value');
				let name = element.getAttribute('data-name');
				let parent = element.closest('.accolades-list__form-field--container');
				let button = parent.querySelector('.accolades-list__form-field--select-button');
				let box = parent.querySelector('.accolades-list__form-field--select-box');
	
				button.innerHTML = name;
				box.classList.toggle('accolades-list__form-field--select-box-active');
	
			}));
		}

		if(this.clearButton) {
			this.clearButton.addEventListener('click', (event)=>{
	
				this.form.reset();
	
			});
		}

	}

	closeAllSelects() {

		this.selectButtons.map((item) => {
			let element = item;
			let parent = element.closest('.accolades-list__form-field--container');
			let box = parent.querySelector('.accolades-list__form-field--select-box');
			box.classList.remove('accolades-list__form-field--select-box-active');

		});

	}

}


// WEBPACK FOOTER //
// ./components/accolades-list-blocks/accolades-list-blocks.component.ts